const parseCrosswalkCSV = (csvText) =>
  csvText
    .trim()
    .split("\n")
    .slice(1)
    .reduce((crosswalk, line) => {
      const [key, ...values] = line.split(",").map((s) => s?.trim());
      if (key) {
        const standards = values
          .map((s) => s?.replace(/\./g, ":"))
          .filter(Boolean);
        if (standards.length) crosswalk[key] = standards;
      }
      return crosswalk;
    }, {});

const loadCrosswalk = async () => {
  try {
    const [readingText, englishText] = await Promise.all([
      fetch("/ela_reading_crosswalk.csv").then((r) => r.text()),
      fetch("/ela_english_crosswalk.csv").then((r) => r.text()),
    ]);

    return {
      reading: parseCrosswalkCSV(readingText),
      english: parseCrosswalkCSV(englishText),
    };
  } catch (error) {
    console.error("Error loading crosswalk:", error);
    return { reading: {}, english: {} };
  }
};

const getTertiaryStandards = async (currentStandards, allStandards) => {
  const crosswalk = await loadCrosswalk();
  const existingCodes = new Set(
    currentStandards.map((s) => s.humanCodingScheme),
  );
  const standardsMap = new Map(
    allStandards.map((s) => [s.humanCodingScheme, s.documentSubject]),
  );
  const tertiarySet = new Set();

  currentStandards.forEach((std) => {
    if (["primary", "secondary"].includes(std.order?.toLowerCase())) {
      const lalCodes =
        crosswalk.reading[std.humanCodingScheme] ||
        crosswalk.english[std.humanCodingScheme];
      lalCodes?.forEach((code) => {
        if (standardsMap.has(code) && !existingCodes.has(code))
          tertiarySet.add(code);
      });
    }
  });

  return Array.from(tertiarySet).map((code) => ({
    humanCodingScheme: code,
    order: "tertiary",
  }));
};

const supportsAutomatedStandards = (contentArea) =>
  contentArea && /english|reading/i.test(contentArea);

export {
  parseCrosswalkCSV,
  loadCrosswalk,
  getTertiaryStandards,
  supportsAutomatedStandards,
};
